import firebase from "firebase"

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD9IcD6fvlURnL1TuZdYGLIb1PoPtu2BZ0",
  authDomain: "turnhalle---outdoor.firebaseapp.com",
  projectId: "turnhalle---outdoor",
  storageBucket: "turnhalle---outdoor.appspot.com",
  messagingSenderId: "706342469538",
  appId: "1:706342469538:web:73b0c4920781a135c03cfb",
  measurementId: "G-1TVJ0MGY4H"
};

  export default firebase.initializeApp(firebaseConfig);